(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__slideshowNatureMaskTransition) return;
    window.__slideshowNatureMaskTransition = true;

    const animationClass = 'nature-mask-animate';
    const selector = 'slideshow-component.slideshow--nature-mask';

    const animateSlide = (slide) => {
      if (!(slide instanceof HTMLElement)) return;

      const slideshow = slide.closest(selector);
      if (!slideshow) return;

      slideshow.querySelectorAll(`slideshow-slide.${animationClass}`).forEach((activeSlide) => {
        activeSlide.classList.remove(animationClass);
      });

      slide.classList.remove(animationClass);
      void slide.offsetWidth;
      slide.classList.add(animationClass);
    };

    const animateActiveSlide = (slideshow) => {
      if (!(slideshow instanceof HTMLElement) || !slideshow.matches(selector)) return;

      animateSlide(slideshow.querySelector("slideshow-slide[aria-hidden='false']"));
    };

    document.addEventListener('slideshow:select', (event) => {
      animateSlide(event.detail?.slide);
    });

    document.addEventListener('shopify:section:load', (event) => {
      event.target?.querySelectorAll(selector).forEach(animateActiveSlide);
    });

    document.querySelectorAll(selector).forEach(animateActiveSlide);
  })();

  } catch(e) { console.error(e); }
})();
})();
